import React from "react";
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, } from '@material-ui/core';
import Button from "../CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

function CustomDialog({ ...props }) {
    const { classes } = props;
    return (
        <Dialog
            className={classes.dialog}
            open={props.noProduct ? props.showNoProductMessage : props.showDialogForDelete}
            onClose={props.closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {props.noProduct
            ? <DialogTitle id="alert-dialog-title">Need to create product</DialogTitle>
            : <DialogTitle 
                id="alert-dialog-title" 
                style={{ backgroundColor: "green", fontSize: "18px", color: "white" }}>
                    <p style={{color: "white"}}>
                        Please Confirm
                    </p>
            </DialogTitle>}
            
            {props.noProduct
            ? <DialogContent>
                <DialogContentText id="alert-dialog-description">
                Please create atleast one product to create an order.
                </DialogContentText>
            </DialogContent>
            : <DialogContent style={{ marginTop: "10px" }}>
                Are you sure you want to <b>delete this {props.deleteWho}</b>{props.product ? ', all linked orders will be hampered?': '?'}
            </DialogContent>}

            <DialogActions>
                {props.noProduct
                ? <Button onClick={props.goBack} color="success" autoFocus>Ok</Button>
                : <>
                    <Button onClick={props.closeDialog} color="danger" style={{marginRight: "5px"}}>No</Button>
                    <Button onClick={props.handleYes} color="success" autoFocus>Yes</Button>
                </>}
            </DialogActions>
        </Dialog> 
    );
}

export default withStyles({})(CustomDialog);